import { useQuery } from '@tanstack/react-query';

import { getDiscoveryService } from '../services/discoveryService';
import { useManifest } from './useManifest';

export function usePlaces(clientName: string) {
  const discoveryService = getDiscoveryService()!;

  const { data } = useManifest(clientName);
  const etag = discoveryService?.getPlacesEtag();

  return useQuery({
    staleTime: Infinity,
    queryKey: ['places.json', clientName, etag],
    enabled: !!data,
    queryFn: async () => discoveryService.getPlaces(),
  });
}
